import React, { useRef } from "react";
import { useVirtualizer } from "@tanstack/react-virtual";
import { Box, Typography } from "@mui/material";
import { SimpleTextInput } from "components/FormTextInput";

const TerritoryXpVirtualList = ({
  territoryEntries,
  territoryXpErrors,
  handleTerritoryXpValueChange,
}) => {
  const parentRef = useRef<HTMLDivElement>(null);

  const rowVirtualizer = useVirtualizer({
    count: territoryEntries.length,
    getScrollElement: () => parentRef.current,
    estimateSize: () => 85, // estimated row height
    overscan: 5,
  });

  return (
    <Box
      ref={parentRef}
      sx={{
        height: "30vh",
        overflowY: "auto",
        px: 1,
      }}
    >
      <Box
        sx={{
          height: `${rowVirtualizer.getTotalSize()}px`,
          width: "100%",
          position: "relative",
        }}
      >
        {rowVirtualizer.getVirtualItems().map((virtualRow) => {
          const [code, value] = territoryEntries[virtualRow.index];

          return (
            <Box
              key={code}
              ref={rowVirtualizer.measureElement}
              data-index={virtualRow.index}
              sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                transform: `translateY(${virtualRow.start}px)`,
              }}
            >
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns:
                    "minmax(140px, 1fr) minmax(180px, 1fr)",
                  gap: 1,
                  py: 1,
                  borderBottom: "1px solid #f0f0f0",
                  alignItems: "center",
                }}
              >
                <Typography>{code}</Typography>

                <SimpleTextInput
                  label=""
                  type="number"
                  name={code}
                  value={value ?? ""}
                  onChange={(event: any) =>
                    handleTerritoryXpValueChange(
                      code,
                      event.target.value
                    )
                  }
                  error={Boolean(territoryXpErrors[code])}
                  helperText={territoryXpErrors[code]}
                />
              </Box>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export default TerritoryXpVirtualList;